import { priceImprovementBlotterApiConnector } from 'apiConnector/blotters/priceImprovementBlotter';
import { ComponentType, PropsWithChildren } from 'react';
import { httpClient } from 'utils/http/httpClient';

const priceImprovementBlotterApi = priceImprovementBlotterApiConnector(httpClient);

type ComponentWithoutFetchCsvApi<P> = ComponentType<PropsWithChildren<Pick<P, Exclude<keyof P, 'fetchCSV'>>>>;

export const withFetchCsvApi =
  <
    P extends {
      fetchCSV: typeof priceImprovementBlotterApi.fetchCSV;
    },
  >(
    Component: ComponentType<P>,
  ): ComponentWithoutFetchCsvApi<P> =>
  props =>
    (
      // @ts-ignore: TS2322
      <Component {...props} fetchCSV={priceImprovementBlotterApi.fetchCSV} />
    );
